import { useTranslations } from 'next-intl';

import { TextButton } from '@flipster/react/design-system/text-button';

import type { TpslButtonStateProps } from './identity';
import { useTpslManageClick } from './use-tpsl-manage-click';

/** TP/SL 미설정(count 0) — 설정 진입점 "Set" 버튼 */
export const TpslButtonEmpty = (props: TpslButtonStateProps) => {
  const { size = 'small', disabled } = props;
  const transAssets = useTranslations('Assets.r250401');

  const handleClick = useTpslManageClick({ ...props, guardTradable: true });

  return (
    <TextButton
      as='button'
      color='neutral'
      size={size}
      disabled={disabled}
      label={transAssets('Set')}
      onClick={handleClick}
    />
  );
};
